import React from 'react';

import { useSonTranslation } from '../../../../../translation/useSonTranslation';

/**
 * Renders a Symbol that signals that a form element is required for a submit.
 */
export function FormRequiredSymbol() {
  const { t } = useSonTranslation('FormRequiredSymbol');

  return (
    // can be aria hidden, because irrelevant for screen readers
    <span className="form-required-symbol" title={t('required')} aria-hidden="true">
      {' '}
      *
    </span>
  );
}
